<script lang="ts" setup>
import type { FaqStorefrontSpecificSchema } from '~/types/storyblok/faq-storefront-specific'
import { useStorefrontStore } from '~/stores/storefront'

const props = defineProps<{ blok: FaqStorefrontSpecificSchema }>()
const { currentStorefrontCode } = storeToRefs(useStorefrontStore())

const show = computed(() => {
  const { excludeFrom, showOn } = props.blok
  if (excludeFrom.length > 0)
    return !excludeFrom.includes(currentStorefrontCode.value)
  if (showOn.length > 0)
    return showOn.includes(currentStorefrontCode.value)
  return true
})
</script>

<template>
  <div v-editable="blok">
    <div v-if="show">
      <component
        :is="content.component"
        v-for="content in blok.content"
        :id="'id' in content ? content.id : undefined"
        :key="content._uid"
        :blok="content"
      />
    </div>
  </div>
</template>
